import { courseUiText } from "../copy.js";
import Icon from "./icon.marko";

<const/uiLang=$global.uiLang || input.copy?.uiLang || 'en'/>

<const/copy=input.copy/>
<header class="ll-course-lesson-bar">
  <a class="ll-course-icon-button" href=input.back aria-label=copy.back title=copy.back>
    <Icon name="close" size=20/>
  </a>
  <div class="ll-course-lesson-bar__mid">
    <div class=["ll-course-steps",input.script&&"ll-script-stages"] data-ll-step-bar>
      <for|step| of=input.steps>
        <button type="button" ...(input.script?{'data-script-go':step}:{'data-ll-go':step}) aria-label=input.labels[step] title=input.labels[step]></button>
      </for>
    </div>
    <span class="ll-course-lesson-bar__label">
      <if=input.sceneNumber>${input.kindLabel || copy.scene} ${input.sceneNumber} · </if><if=input.unitNumber>${courseUiText("Unit {n}", uiLang, {n: input.unitNumber})} · </if><bdi lang=input.lang dir="auto">${input.title}</bdi> · <span data-ll-step-label>${input.labels[input.steps[0]]}</span>
    </span>
  </div>
  <div class="ll-course-lesson-bar__end">
    <if=input.script && input.alphabet !== false><button type="button" class="ll-course-ghost ll-script-alphabet-button" data-script-alphabet-open><Icon name="file"/> ${courseUiText("Alphabet", uiLang)}</button></if>
    <if=input.learner !== false>
      <div class="ll-course-who" role="group" aria-label=copy.learner>
        <button type="button" data-ll-gender-set="f" aria-pressed="true">Lena</button>
        <button type="button" data-ll-gender-set="m" aria-pressed="false">Lukas</button>
      </div>
    </if>
    <if=input.script><button type="button" class="ll-course-ghost ll-course-restart" data-script-restart>${copy.restart}</button></if>
    <else><button type="button" class="ll-course-ghost ll-course-restart" data-ll-restart hidden>${copy.restart}</button></else>
  </div>
</header>
